import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.303.697c.488.488.452 1.315-.08 1.848L7.768 6l3.455 3.455c.532.533.568 1.36.08 1.848-.488.488-1.315.452-1.848-.08L6 7.768l-3.455 3.455c-.533.532-1.36.568-1.848.08-.488-.488-.452-1.315.08-1.848L4.232 6 .777 2.545C.245 2.012.21 1.185.697.697c.488-.488 1.315-.452 1.848.08L6 4.232 9.455.777c.533-.532 1.36-.568 1.848-.08Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol